import { getAge } from '@src/utils'
import { getFactorsDynamic } from '@src/api'


function arrToObj(arr=[], keyWord) {
  let obj = {}
  arr.forEach(item => {
    const key = item[keyWord]
    obj[key] = item
  })
  return obj
}

// 获取年龄范围
export const getAgeRangeArr = (fromDate, toDate) => {
  const minAge = getAge(toDate)
  const maxAge = getAge(fromDate)
  const arr = []
  for (let i = minAge; i <= maxAge; i++) {
    const obj = {
      customizeText: String(i),
      customizeValue: String(i)
    }
    arr.push(obj)
  }
  console.log('arr: ', arr)
  return arr
}

// 获取试算因子配置
export async function requestFactors({goodsId, planId}, t) {
  // 现在只会有一个计划 获取动态因子
  const param = {
    goodsId,
    goodsPlanId: planId,
    goodPlanId: planId,
    categoryEnum: 'PREMIUMFACTOR',
    topicEnum: 'TRIAL'
  }
  const data = await getFactorsDynamic(param)
  console.log('data: ', data);
  if(!data || data.length === 0) return;
  let factorCfg = arrToObj(data, 'customizeCode')
  factorCfg = {
    gender: handleGenderConfig(factorCfg.gender),
    smoking: handleSmokingConfig(factorCfg.smoking, t),
    age: handleAgeConfig(factorCfg.birthday, t),
    paymentPeriod: handlePeriodConfig(factorCfg.paymentPeriod, t),
    SA: handleSAConfig(factorCfg.SA),
    payFrequencyType: handlePayFrequencyTypeConfig(factorCfg.payFrequencyType)
  };
  console.log('factorCfg222: ', factorCfg);

  return factorCfg;
}

// 性别因子配置
function handleGenderConfig(config){
  return {
    customizeCode: config?.customizeCode,
    title: config?.customizeName,
    defaultValue: config?.show?.defaultValue || 'MALE',
    defaultOptions: config?.values.map((item) => {
      return {
        customizeValue: item.customizeValue,
        customizeText: item.customizeText.replace('性', '') // 只显示一个字
      }
    }),
  }
}

// 吸烟状况因子配置
function handleSmokingConfig(config, t) {
  return {
    customizeCode: config?.customizeCode,
    title: t('anan_resp_edigest_factor_smoking') || '吸煙狀況',
    defaultValue: config?.show?.defaultValue || 'NO',
    defaultOptions: config?.values || []
  }
}

// 获取年龄配置
function handleAgeConfig(config, t) {
  return {
    customizeCode: 'age',
    title: t('anan_resp_edigest_factor_age') || '年齡',
    defaultValue: getAge(config?.show?.defaultValue) || '31',
    defaultOptions: getAgeRangeArr(config?.show?.minValue, config?.show?.maxValue) || []
  }
}

// 获取保单保障期配置
function handlePeriodConfig(config, t) {
  return {
    customizeCode: config?.customizeCode,
    title: config?.customizeName,
    defaultValue: config?.show?.defaultValue,
    defaultOptions: config?.values || [],
    toolTip: t('anan_resp_product_intl_benefit_term_tip') || 'Premium guaranteed unchanged within benefit term. Subsequent premiums may change based on attained age and claim experience of the company. Choosing longer benefit term can lock-in your premium now.'
  }
}

// 获取保额配置
function handleSAConfig(config) {
  return {
    customizeCode: config?.customizeCode,
    title: config?.customizeName,
    defaultValue: config?.show?.defaultValue,
    maxValue: config?.show?.maxValue,
    minValue: config?.show?.minValue,
    step: 100000
  }
}

// 获取缴付模式配置
function handlePayFrequencyTypeConfig(config) {
  return {
    customizeCode: config?.customizeCode,
    title: config?.customizeName,
    defaultValue: config?.show?.defaultValue || config?.values[0].customizeValue,
    defaultOptions: config?.values || [],
  }
}
